import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaymentMethodConfig, PaymentOptionType } from './payment-method.models';
import { Labels } from 'src/app/app.models';


// Todo: #CMS
const paymentMethodConfig: PaymentMethodConfig = {
  textHeader: 'Payment Method',
  paymentMethodOptions: [
    {
      isEnabled: true,
      icon: 'assets/images/payment-method-icons/payment-method-cash-icon.svg',
      iconAltText: 'cash pickup-dropoff location icon',
      title: 'Cash at location',
      subtitle: 'fee',
      fee: '$--.--',
      displayComingSoon: false,
      optionType: 'cash'
    },
    {
      isEnabled: false,
      icon: 'assets/images/payment-method-icons/payment-method-debit-icon.svg',
      iconAltText: 'payment method debit icon',
      title: 'Debit card',
      subtitle: 'fee',
      fee: '$0',
      displayComingSoon: false,
      optionType: 'debit'
    },
    {
      isEnabled: false,
      icon: 'assets/images/payment-method-icons/payment-method-bank-icon.svg',
      iconAltText: 'payment method bank account icon',
      title: 'Bank Account',
      subtitle: '',
      fee: '',
      displayComingSoon: true,
      optionType: 'bank'
    }
  ]
}

@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss']
})
export class PaymentMethodComponent {
  @Output() changePaymentMethodEvent = new EventEmitter<PaymentOptionType>();

  @Input() public google: any;
  @Input() kind: string;
  @Input() isSdfCardFlow: boolean = true;
  @Input() labels: Labels;
  @Input() public selectedPaymentMethod: PaymentOptionType | null;
  @Input() public isCashEnabled: boolean;
  @Input() public isDebitEnabled: boolean;
  @Input() public isBankAccountEnabled: boolean;
  @Input() public isLocationSelected: boolean | null;
  public config: PaymentMethodConfig;

  ngOnInit(): void {
    this.config = paymentMethodConfig;
    this.setEnabledOptions();
  }

  public selectPaymentMethod(optionType: PaymentOptionType): void {
    if (optionType === this.selectedPaymentMethod) return;
    this.changePaymentMethodEvent.emit(optionType);
  }

  private setEnabledOptions(): void {
    this.config.paymentMethodOptions[0].isEnabled = this.isCashEnabled;
    this.config.paymentMethodOptions[1].isEnabled = this.isDebitEnabled;
    this.config.paymentMethodOptions[2].isEnabled = this.isBankAccountEnabled;
  }
}
